<kv-editor-container [menuItems]="menuItems" [title]="title" menuTag="menuTag" [menuGroups]="menuGroups" [inputComponent]="inputComponent"></kv-editor-container>
<!--     <ng-template editorContentTemplate [menuItems]="menuItems" [title]="title" menuTag="menuTag" [menuGroups]="menuGroups">
        <p>I come from footer</p>
    </ng-template>
</kv-editor-container> -->
